import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import type { RadioGroupProps } from '@mui/material/RadioGroup';

import { Sxable } from 'library/types';

interface RadioGroupDisplayProps extends Sxable {
	value: RadioGroupProps['value'];
	row?: RadioGroupProps['row'];
	radioLabelsList: { id: unknown; label: React.ReactNode }[];
}

export const RadioGroupDisplay = ({
	value,
	radioLabelsList,
	row,
	sx = [],
}: RadioGroupDisplayProps): React.JSX.Element => {
	return (
		<FormControl sx={sx}>
			<RadioGroup row={row} value={value}>
				{radioLabelsList.map((type) => (
					<FormControlLabel
						key={type.id as string}
						value={type.id}
						control={
							<Radio size="small" color="secondary" readOnly />
						}
						label={type.label}
					/>
				))}
			</RadioGroup>
		</FormControl>
	);
};
